<div id="quotas" *psUiHasRole="['buyer', 'operator']">
  <div class="templateRoot group-edit" *ngIf="isQuotasExist">
    <!-- Search process -->
    <form class="form-inline">
      <div>
        <div class="row vertical-center">
          <div class="col-md-3 col-sm-12 inside_first_groupMgmt">
            <div *ngIf="!quotaViewFlags.supplierview">Search Quotas</div>
            <div class="btn-group d-flex" *ngIf="!quotaViewFlags.supplierview">
              <div class="quota-search-container">
                <input
                  type="text"
                  name="quotaSearch"
                  class="form-control"
                  [(ngModel)]="quotaSearch"
                  (change)="searchQuotas(quotaSearch)"
                />
                <span
                  class="fa fa-times-circle form-control-feedback search-cross-icon"
                  aria-hidden="true"
                  (click)="searchQuotas('')"
                  *ngIf="quotaSearch"
                ></span>
              </div>
              <div class="edit-button-group" *ngIf="checkQuotaFilterEnabled()">
                <div
                  class="glyphicon fa fa-filter btn-tm quota-filter-btn"
                  (click)="toggleQuotaFilterTM()"
                ></div>
              </div>
            </div>
          </div>
          <div
            class="col-md-6 inside_third_groupMgmt vl projected-cpi-div"
            *ngIf="quotaViewFlags.priceview"
          >
            <br />
            <div>
              <p class="cost-label">Projected Cost</p>
            </div>
            <div class="projected-cpi-div-cost-label">
              <div>
                <label class="control-label">Current </label>
                <label class="control-label font-14">
                  {{ projectedCurrentCpi | currency : survey.currencySymbol }}
                </label>
              </div>
              <div>
                <label class="control-label">Recommended </label>
                <label class="control-label font-14">
                  {{
                    projectedRecommendedCpi | currency : survey.currencySymbol
                  }}
                </label>
              </div>
            </div>
          </div>
          <div
            class="col-md-6 inside_third_groupMgmt"
            *ngIf="!quotaViewFlags.supplierview && !quotaViewFlags.priceview"
          >
            <div class="center-align">Grouped Field Management</div>
            <div class="row center-align">
              <div class="editct-btn">
                <div class="help-tip current-target">
                  <div class="edit-slide">
                    <ps-ui-slider
                      id="entryLinks"
                      [selected]="
                        editCT && editableCurrentTarget.history().length > 1
                      "
                      [disabled]="survey.is_feot_enabled || isQbpChildSurvey"
                      (selectedChange)="editAllCT($event)"
                    ></ps-ui-slider>
                    <span class="selectBtn">Edit CT</span>
                  </div>
                  <div class="edit-slide">
                    <ps-ui-slider
                      id="entryLinks"
                      [selected]="
                        editCO && editableCurrentOpen.history().length > 1
                      "
                      [disabled]="survey.is_feot_enabled || isQbpChildSurvey"
                      (selectedChange)="editAllCO($event)"
                    ></ps-ui-slider>
                    <span class="selectBtn">Edit CO</span>
                  </div>
                  <p *ngIf="survey.is_feot_enabled || isQbpChildSurvey">
                    <span
                      >Editing Current Target is disabled while FEOT is enabled/
                      is QBP child feature.</span
                    >
                  </p>
                </div>
              </div>

              <button
                type="button"
                class="btn btn-primary btn-round-sm btn-sm edit-btn-radius"
                [ngClass]="{
                  sliderBGcolorChng:
                    !lockUnlockGroupStatus.groupLockUnlockStatus,
                  muteSliderColor: lockUnlockGroupStatus.fadeoptcitylock
                }"
                (click)="updateLockUnlockQuotaGroup(survey.id)"
                [disabled]="isQbpChildSurvey"
              >
                {{
                  lockUnlockGroupStatus.groupLockUnlockStatus === true
                    ? 'Unlock'
                    : 'Lock'
                }}
              </button>

              <div class="col-sm-8 col-md-12 col-lg-8 row center-align">
                <div class="col-sm-3 padding-zero">
                  <label class="edit-ct-label">Current Target</label>
                </div>
                <div class="col-sm-3 padding-zero">
                  <input
                    class="form-control edit-ct-input-box"
                    [disabled]="survey.is_feot_enabled || isQbpChildSurvey"
                    [(ngModel)]="editCurrentTarget.value"
                    name="quota-ct"
                    type="text"
                  />
                </div>
                <div class="col-sm-4 padding-zero edit-ct-type-dropdown">
                  <button
                    psUiButton
                    [psUiDropdownToggleFor]="menu"
                    class="form-control edit-ct-input-box padding-zero gfmType"
                    [disabled]="survey.is_feot_enabled || isQbpChildSurvey"
                  >
                    {{ editCurrentTarget.type }}
                  </button>
                  <ps-ui-dropdown #menu="psUiDropdown">
                    <ps-ui-dropdown-item
                      (click)="
                        editCurrentTarget.type =
                          Constants.CURRENT_TARGET_TYPE.NUMBER
                      "
                      >Number</ps-ui-dropdown-item
                    >
                    <ps-ui-dropdown-item
                      (click)="
                        editCurrentTarget.type =
                          Constants.CURRENT_TARGET_TYPE.PERCENTAGE
                      "
                      >Percentage
                    </ps-ui-dropdown-item>
                  </ps-ui-dropdown>
                </div>
                <div class="col-sm-2 padding-zero edit-ct-check-div">
                  <div
                    class="fa fa-check edit-ct-input-box edit-ct-check"
                    type="button"
                    (click)="updateCurrentTarget()"
                  ></div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="col-md-2 col-sm-12 inside_scnd_groupMgmt"
            [ngClass]="{ 'offset-md-6': quotaViewFlags.supplierview }"
          >
            <div>View By</div>
            <div class="btn-group">
              <button
                type="button"
                class="btn btn-primary view_by_quota"
                (click)="setHeaderQuotaView()"
                [ngClass]="{
                  quotaview_active:
                    quotaViewFlags.quotaview === true
                      ? quotaViewFlags.quotaview
                      : false
                }"
                psUiGtagEvent
                trackOn="click"
                action="quota_quota"
                category="Tabs"
                [params]="{ event_label: 'Quota - Quota View' }"
              >
                Quota
              </button>
              <button
                type="button"
                class="btn btn-primary view_by_supplier-1"
                (click)="getSuppliers(survey.id)"
                [ngClass]="{
                  supplierview_active:
                    quotaViewFlags.supplierview === true
                      ? quotaViewFlags.supplierview
                      : false
                }"
                psUiGtagEvent
                trackOn="click"
                action="quota_supplier"
                category="Tabs"
                [params]="{ event_label: 'Quota - Supplier View' }"
              >
                Supplier
              </button>
              <button
                *ngIf="showPriceButton"
                type="button"
                class="btn btn-primary view_by_price price-button"
                (click)="openPriceQuotaView()"
                [ngClass]="{
                  priceview_active: quotaViewFlags.priceview,
                  glowbutton: showPriceButtonGlow
                }"
                psUiGtagEvent
                trackOn="click"
                action="quota_price"
                category="Tabs"
                [params]="{ event_label: 'Quota - Price View' }"
              >
                Price
              </button>
            </div>
          </div>
        </div>
      </div>
    </form>
    <!-- Filter process -->
    <div
      class="d-flex quota-filter-container"
      *ngIf="toggleQuotaFilterTMStatus && !quotaViewFlags.supplierview"
    >
      <div class="dropdown-multiselect-tm">
        <button
          [options]="dateRangeOptions"
          [(ngModel)]="psEntDtRange"
          name="dateRange"
          daterangepicker
          ngDefaultControl
          (selected)="selectPSEntryDate($event)"
          class="btn btn-default datepicker-button quota-filter-button"
          [ngClass]="{ 'button-ps-entry-date-activated': isActiveDate }"
        >
          PS Entry Date {{ psEntryDateForDRP }}
          &nbsp;
          <em *ngIf="!isActiveDate" class="fa fa-angle-down"></em>
          <em
            *ngIf="isActiveDate"
            (click)="removePSEntryDate()"
            class="fa fa-times-circle fa-lg"
          ></em>
        </button>
      </div>
      <div class="traffic-channel-container">
        <ng-select
          #trafficChannelDropdown
          class="custom quota-filter-button"
          [clearable]="false"
          placeholder="Traffic Channels"
          [multiple]="true"
          notFoundText="No Survey Available"
          [items]="trafficChannelList"
          [closeOnSelect]="false"
          bindLabel="title"
          bindValue="id"
          dropdownPosition="bottom"
          [searchable]="false"
          [(ngModel)]="selectedTrafficChannels"
        >
          <ng-template ng-option-tmp let-item="item" let-item$="item$">
            <input type="checkbox" [ngModel]="item$.selected" />
            {{ item.title }}
          </ng-template>
          <ng-template ng-footer-tmp *ngIf="trafficChannelList.length">
            <button
              class="btn btn-primary btn-sm pull-right"
              (click)="filterTrafficChannelQuotas(trafficChannelDropdown)"
            >
              Apply
            </button>
            <button
              class="btn btn-default btn-sm pull-right btn-margin"
              (click)="
                selectedTrafficChannels = []; filterTrafficChannelQuotas()
              "
              type="button"
            >
              Clear
            </button>
          </ng-template>
        </ng-select>
      </div>
    </div>
    <!-- Tabulated search result -->
    <div class="table-responsive quota-table">
      <!-- No Quota found in search -->
      <ng-container *ngIf="formatQuotas === {} || isObjKeysEmpty(formatQuotas)">
        <div class="surveyDetailsTableWrapper no-match-wrapper">
          <p class="text-center m-0 text-uppercase text-decor">
            <strong>No Matching Quotas Found</strong>
          </p>
        </div>
      </ng-container>
      <!-- Quota View -->
      <ng-container *ngIf="quotaViewFlags.quotaview">
        <div
          class="surveyDetailsTableWrapper"
          *ngFor="let quota of formatQuotas | keyvalue : originalOrder"
        >
          <table
            class="table survey-detail-table"
            aria-label="Quota View Table"
          >
            <thead>
              <tr class="sticky-header">
                <th
                  class="text-left first-quota-column"
                  [psUiSortTable]="quota.value"
                  data-order=""
                  data-name="quota_title"
                >
                  <strong class="np_tp_row icon-position">
                    {{ quota.key }}
                    <div
                      class="help-tip current-target new_tp tp-2"
                      *ngIf="quota.value[0].in_field"
                    >
                      <i class="fa fa-info-circle" aria-hidden="true"></i>
                      <p>
                        <span
                          >This quota was created after the survey launch. As a
                          result, the completes across this quota may not add up
                          to the total. At the time this quota was created, the
                          survey had already collected completes.</span
                        >
                      </p>
                    </div>
                  </strong>
                </th>
                <th
                  class="text-center single-line"
                  [psUiSortTable]="quota.value"
                  data-order=""
                  data-name="required_count"
                >
                  {{
                    survey.click_balancing === 1
                      ? 'Click Fielded Vs Click Goal'
                      : 'Fielded Vs Goal'
                  }}
                </th>
                <th
                  class="text-center min-wid-175 current-target-th"
                  [psUiSortTable]="quota.value"
                  data-order=""
                  data-name="current_target"
                >
                  <label class="mid-icon-position">
                    {{
                      survey.click_balancing === 1
                        ? 'Clicks Current Target'
                        : 'Current Target'
                    }}
                    <div class="help-tip current-target tp-2">
                      <i class="fa fa-info-circle" aria-hidden="true"></i>
                      <p>
                        <span
                          >For Field Management, you can change the Currently
                          Open amount by changing the Current Target. Currently
                          Open = Current Target - Achieved.</span
                        >
                      </p>
                    </div>
                  </label>
                </th>
                <th
                  class="text-center currently-open-header"
                  [psUiSortTable]="quota.value"
                  data-order=""
                  data-name="currently_open"
                >
                  Currently Open
                </th>
                <th
                  class="text-center quota_th"
                  [psUiSortTable]="quota.value"
                  data-order=""
                  data-name="achieved"
                >
                  Quota Progress
                </th>
                <th
                  class="text-center min-100"
                  [psUiSortTable]="quota.value"
                  data-order=""
                  data-name="bip"
                >
                  In Progress
                </th>
                <th class="text-center min-100 accordian-header"></th>
              </tr>
            </thead>

            <tbody>
              <tr>
                <td colspan="7">
                  <ps-ui-accordion
                    [closeOthers]="true"
                    [arrowToggleOnly]="true"
                    class="survey-quota-accordion"
                  >
                    <ps-ui-accordion-section
                      class="accordion-section"
                      *ngFor="
                        let item of quota.value;
                        let i = index;
                        trackBy: quotaTrackBy
                      "
                      tabindex="-1"
                    >
                      <ng-template psUiAccordionTitle>
                        <table
                          class="quota-accordion quota-accordion-width"
                          aria-label="Quota View Accordion table"
                        >
                          <tr
                            [ngClass]="{
                              quotagroupselected:
                                item.editCurrntTrgtActive === true
                                  ? item.editCurrntTrgtActive
                                  : false,
                              editmarkcolorchange: checkhover
                            }"
                            (mouseover)="checkhover = true"
                            (mouseout)="checkhover = false"
                            (click)="
                              checkGroupLockUnlockQuotaStatus(
                                survey.id,
                                quota.key,
                                item.ps_quota_id,
                                i
                              )
                            "
                          >
                            <th
                              *ngIf="quota.key !== 'zipcodes'"
                              class="text-left width-20"
                              title="{{ item.marker }}"
                            >
                              <div class="hover-edit-quota">
                                <div
                                  class="quota-name first-quota-column"
                                  *ngIf="item && item.quota_title"
                                >
                                  {{ item.quota_title }}
                                  <em
                                    data-toggle="modal"
                                    [attr.data-target]="
                                      '#Nickname_' + item.ps_quota_id
                                    "
                                    class="fa fa-pencil edit-quota-pencil glyphicon glyphicon-pencil"
                                    (click)="
                                      updateQuotaTitle(
                                        item.ps_quota_id,
                                        item.quota_title,
                                        item.criteria,
                                        quota.key,
                                        i
                                      )
                                    "
                                  ></em>
                                </div>
                              </div>

                              <div
                                *ngIf="!item.isUnknown"
                                class="expanded_quota_modal"
                                mouseover="$event.stopPropagation(); checkhover = false;"
                              >
                                <em
                                  data-toggle="modal"
                                  data-target="#quota-Info-modal"
                                  class="fa fa-ellipsis-h"
                                  (click)="openInfoModal(item)"
                                ></em>
                              </div>
                              <a
                                *ngIf="!item.isUnknown"
                                (click)="
                                  lockQuota(
                                    survey.id,
                                    quota.key,
                                    item.ps_quota_id,
                                    !item.locked,
                                    i
                                  );
                                  avoidClick($event)
                                "
                                class="lockQuotasIcon"
                              >
                                <img
                                  [src]="
                                    item.locked === true
                                      ? lockQuotaImg
                                      : unLockQuotaImg
                                  "
                                  alt="lock_quota"
                                  class="img-responsive"
                                />
                              </a>
                            </th>
                            <th
                              *ngIf="quota.key === 'zipcodes'"
                              class="text-left"
                              title="{{ item.marker }}"
                            >
                              test
                            </th>
                            <th class="text-center min-44">
                              {{
                                survey.click_balancing === 1
                                  ? manageCap(item.buyer_valid_clks)
                                  : manageCap(item.achieved)
                              }}&nbsp;|&nbsp;{{
                                manageCap(item.required_count)
                              }}
                            </th>
                            <th class="text-center min-wid-175">
                              <div
                                class="hover-edit-quota"
                                *ngIf="
                                  !editableCurrentTarget.status(
                                    item.ps_quota_id
                                  )
                                "
                              >
                                <div
                                  *ngIf="
                                    !item.isUnknown &&
                                    !survey.is_feot_enabled &&
                                    !isQbpChildSurvey
                                  "
                                  click-edit
                                  loader="loader.show"
                                  type="inputText"
                                  (click)="
                                    avoidClick($event);
                                    !editCO && enableEditCT(item.ps_quota_id)
                                  "
                                >
                                  {{ manageCap(item.current_target) }}
                                  <em
                                    *ngIf="!editCO"
                                    class="fa fa-pencil edit-quota-pencil glyphicon glyphicon-pencil"
                                    (click)="enableEditCT(item.ps_quota_id)"
                                  ></em>
                                </div>
                                <div
                                  *ngIf="
                                    !item.isUnknown &&
                                    (survey.is_feot_enabled || isQbpChildSurvey)
                                  "
                                  loader="loader.show"
                                  type="inputText"
                                  (click)="avoidClick($event)"
                                >
                                  {{ manageCap(item.current_target) }}
                                </div>
                              </div>
                              <ps-ui-edit-current-value
                                [id]="item.ps_quota_id"
                                [value]="item.current_target"
                                (update)="updateEditQuotaCT($event)"
                                (cancel)="
                                  resetEditQuota($event, editableCurrentTarget)
                                "
                                *ngIf="
                                  editableCurrentTarget.status(item.ps_quota_id)
                                "
                              ></ps-ui-edit-current-value>
                            </th>
                            <th class="text-center">
                              <div
                                class="hover-edit-quota"
                                *ngIf="
                                  !editableCurrentOpen.status(item.ps_quota_id)
                                "
                              >
                                <div
                                  *ngIf="
                                    !item.isUnknown &&
                                    !survey.is_feot_enabled &&
                                    !isQbpChildSurvey!
                                  "
                                  click-edit
                                  loader="loader.show"
                                  type="inputText"
                                  (click)="
                                    avoidClick($event);
                                    !editCT && enableEditCO(item.ps_quota_id)
                                  "
                                >
                                  <span *ngIf="!item.isUnknown">{{
                                    item.locked === true
                                      ? manageCap(0)
                                      : manageCap(item.currently_open)
                                  }}</span>
                                  <em
                                    *ngIf="!editCT"
                                    class="fa fa-pencil edit-quota-pencil glyphicon glyphicon-pencil"
                                    (click)="enableEditCO(item.ps_quota_id)"
                                  ></em>
                                </div>
                                <div
                                  *ngIf="
                                    !item.isUnknown &&
                                    (survey.is_feot_enabled || isQbpChildSurvey)
                                  "
                                  loader="loader.show"
                                  (click)="avoidClick($event)"
                                >
                                  <span *ngIf="!item.isUnknown">{{
                                    item.locked === true
                                      ? manageCap(0)
                                      : manageCap(item.currently_open)
                                  }}</span>
                                </div>
                              </div>
                              <ps-ui-edit-current-value
                                [id]="item.ps_quota_id"
                                [value]="item.currently_open"
                                (update)="updateEditQuotaCO($event)"
                                (cancel)="
                                  resetEditQuota($event, editableCurrentOpen)
                                "
                                *ngIf="
                                  editableCurrentOpen.status(item.ps_quota_id)
                                "
                              ></ps-ui-edit-current-value>
                            </th>
                            <th class="text-center min-wid-180">
                              <div class="progress-bar-fielded">
                                <div
                                  class="progress-bar-fieldedVsGoal"
                                  role="progressbar"
                                  [attr.aria-valuenow]="item.achieved"
                                  [attr.aria-valuemax]="item.required_count"
                                  [attr.aria-valuemin]="0"
                                  style="width:{{ progress(survey, item) }}%"
                                ></div>
                                <div
                                  class="process-inner"
                                  style="left: {{
                                    item.current_target > item.required_count
                                      ? 100
                                      : item.current_target === 0
                                      ? 0
                                      : (item.current_target /
                                          item.required_count) *
                                        100
                                  }}%"
                                ></div>
                              </div>
                            </th>

                            <th class="text-center">
                              <span>{{ manageCap(item.bip) }}</span>
                            </th>
                          </tr>
                        </table>
                      </ng-template>
                      <div
                        id="layerd{{ item.ps_quota_id }}"
                        class="accordian-body custom_bg"
                      >
                        <table
                          class="supplier-expaneded-quota"
                          aria-label="Quota View Accordion Expand"
                        >
                          <thead>
                            <tr
                              class="expandQuota_accordian quota_accordianrow custom-color"
                            >
                              <th class="text-center">Supplier Name</th>
                              <th class="text-center">
                                {{
                                  survey.click_balancing === 1
                                    ? 'Click Fielded Vs Click Goal'
                                    : 'Fielded Vs Goal'
                                }}
                              </th>
                              <th class="text-center">
                                {{
                                  survey.click_balancing === 1
                                    ? 'Clicks Current Target'
                                    : 'Current Target'
                                }}
                              </th>
                              <th class="text-center">Currently Open</th>
                              <th
                                class="text-center"
                                *psUiHasRole="['operator']"
                              >
                                Supplier Currently Open
                              </th>
                              <th class="text-center">
                                {{
                                  survey.click_balancing === 1
                                    ? 'Completes'
                                    : 'Valid Clicks'
                                }}
                              </th>
                              <th class="text-center">Last Start Date</th>
                              <th class="text-center">Last Complete Date</th>
                              <th class="text-center">Conversion</th>
                              <th class="text-center">In Progress</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              class="expandQuota_accordian quota_accordianrow"
                              [class.pds-tooltip-shown]="hoverRow === $index"
                              *ngFor="
                                let supplier of item.suppliers;
                                let $index = index;
                                let $last = last
                              "
                            >
                              <td class="text-left supplier-pds">
                                {{ supplier.name }}
                                <ps-ui-pds-label
                                  *ngIf="supplier.is_pds_applied"
                                  class="pds-padding"
                                  [companyId]="survey.companyId"
                                  [supplierId]="supplier.supplier_ref_id"
                                  [fee]="supplier.fee"
                                  (mouseover)="hoverRow = $index"
                                  (mouseout)="hoverRow = undefined"
                                  [top]="$last"
                                ></ps-ui-pds-label>
                              </td>
                              <td class="text-center">
                                {{
                                  survey.click_balancing === 1
                                    ? manageCap(supplier.buyer_valid_clks)
                                    : manageCap(supplier.complete_fielded)
                                }}&nbsp;|&nbsp;{{
                                  manageCap(item.required_count)
                                }}
                              </td>
                              <td
                                class="text-center min-wid-100 editmarkcolorchange"
                              >
                                <div
                                  class="hover-edit-quota"
                                  *ngIf="
                                    !editableSupplierQuotaCT.status(
                                      item.ps_quota_id,
                                      supplier.supplier_ref_id
                                    )
                                  "
                                >
                                  <div
                                    *ngIf="!isQbpChildSurvey"
                                    quota_id="item.ps_quota_id"
                                    loader="loader.show"
                                    type="inputText"
                                    update-sup-met-goal-flag="updateSupMetGoalFlag(item.ps_quota_id, supplier.name, supplier.sup_currently_open)"
                                    click-edit
                                    ng-click="avoidClick($event)"
                                    (click)="
                                      editableSupplierQuotaCT.enable(
                                        item.ps_quota_id,
                                        supplier.supplier_ref_id
                                      )
                                    "
                                  >
                                    {{ manageCap(supplier.current_target) }}
                                    <em
                                      class="fa fa-pencil edit-quota-pencil glyphicon glyphicon-pencil"
                                    ></em>
                                  </div>
                                  <div *ngIf="isQbpChildSurvey">
                                    {{ manageCap(supplier.current_target) }}
                                  </div>
                                </div>
                                <ps-ui-edit-current-value
                                  [id]="editableSupplierQuotaCT.current() || ''"
                                  [value]="supplier.current_target"
                                  (update)="updateEditSupplierCT($event)"
                                  (cancel)="editableSupplierQuotaCT.disable()"
                                  *ngIf="
                                    editableSupplierQuotaCT.status(
                                      item.ps_quota_id,
                                      supplier.supplier_ref_id
                                    )
                                  "
                                ></ps-ui-edit-current-value>
                              </td>
                              <td
                                class="text-center min-wid-100 editmarkcolorchange"
                              >
                                <div
                                  class="hover-edit-quota"
                                  *ngIf="
                                    !editableSupplierQuotaCO.status(
                                      item.ps_quota_id,
                                      supplier.supplier_ref_id
                                    )
                                  "
                                >
                                  <div
                                    *ngIf="!isQbpChildSurvey"
                                    quota_id="item.ps_quota_id"
                                    loader="loader.show"
                                    type="inputText"
                                    update-sup-met-goal-flag="updateSupMetGoalFlag(item.ps_quota_id, supplier.name, supplier.sup_currently_open)"
                                    click-edit
                                    ng-click="avoidClick($event)"
                                    (click)="
                                      editableSupplierQuotaCO.enable(
                                        item.ps_quota_id,
                                        supplier.supplier_ref_id
                                      )
                                    "
                                  >
                                    {{ manageCap(supplier.currently_open) }}
                                    <em
                                      class="fa fa-pencil edit-quota-pencil glyphicon glyphicon-pencil"
                                    ></em>
                                  </div>
                                  <div *ngIf="isQbpChildSurvey">
                                    {{ manageCap(supplier.currently_open) }}
                                  </div>
                                </div>
                                <ps-ui-edit-current-value
                                  [id]="editableSupplierQuotaCO.current() || ''"
                                  [value]="supplier.currently_open"
                                  (update)="updateEditSupplierCO($event)"
                                  (cancel)="editableSupplierQuotaCO.disable()"
                                  *ngIf="
                                    editableSupplierQuotaCO.status(
                                      item.ps_quota_id,
                                      supplier.supplier_ref_id
                                    )
                                  "
                                ></ps-ui-edit-current-value>
                              </td>
                              <td
                                class="text-center"
                                *psUiHasRole="['operator']"
                              >
                                {{
                                  item.locked === true
                                    ? 0
                                    : manageCap(supplier.sup_currently_open)
                                }}
                              </td>
                              <td class="text-center">
                                {{
                                  survey.click_balancing === 1
                                    ? manageCap(supplier.complete_fielded)
                                    : manageCap(supplier.buyer_valid_clks)
                                }}
                              </td>
                              <td class="text-center">
                                {{
                                  !supplier.last_start_date
                                    ? '-'
                                    : (supplier.last_start_date
                                      | date : 'MM/dd/yyyy h:mma')
                                }}
                              </td>
                              <td class="text-center">
                                {{
                                  !supplier.last_complete_date
                                    ? '-'
                                    : (supplier.last_complete_date
                                      | date : 'MM/dd/yyyy h:mma')
                                }}
                              </td>
                              <td class="text-center">
                                {{ suppConversionQuota(supplier) }}
                              </td>
                              <td class="text-center" *ngIf="!item.isUnknown">
                                {{ manageCap(supplier['bip']) }}
                              </td>
                              <td class="text-center"></td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </ps-ui-accordion-section>
                  </ps-ui-accordion>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </ng-container>
      <!-- Supplier View  -->
      <ng-container *ngIf="quotaViewFlags.supplierview">
        <div *ngIf="quotaViewFlags.supplierview" class="quotaBySupplier">
          <table
            class="table survey-detail-table"
            [ngClass]="{ 'supplier-dashboard-quotas': filterCompanyDetail }"
            aria-label="Supplier View Table"
          >
            <thead>
              <tr>
                <th class="text-left">&nbsp;</th>
                <th class="text-center">Fielded | Goal</th>
                <th class="text-center">Current Target</th>
                <th class="text-center">Currently Open</th>
                <th class="text-center">Valid Clicks</th>
                <th class="text-center">Last Start Date</th>
                <th class="text-center">Last Complete Date</th>
                <th class="text-center">In Progress</th>
                <th class="text-center">Conversion</th>
                <th class="text-center">&nbsp;</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td colspan="10">
                  <ps-ui-accordion
                    [closeOthers]="true"
                    [arrowToggleOnly]="true"
                  >
                    <ps-ui-accordion-section
                      *ngFor="let supplier of suppliers; let $index = index"
                    >
                      <ng-template psUiAccordionTitle>
                        <table
                          class="supplier-accordion-tbl"
                          aria-label="Supplier View Accordion table"
                        >
                          <tr
                            *ngIf="
                              supplier.completes_goal ||
                              supplier.srv_start_count
                            "
                            data-toggle="collapse"
                            class="accordion-toggle supplier_accordian"
                          >
                            <th class="text-left" (click)="avoidClick($event)">
                              {{ supplier.group_name }}
                              <ps-ui-pds-label
                                *ngIf="supplier.is_pds_applied"
                                class="pds-padding"
                                [companyId]="survey.companyId"
                                [supplierId]="supplier.suppliers[0].id"
                                [cpi]="supplier.cpi"
                                [fee]="supplier.fee"
                                (mouseover)="hoverRow = $index"
                                (mouseout)="hoverRow = undefined"
                              ></ps-ui-pds-label>
                            </th>
                            <th
                              class="text-center"
                              (click)="avoidClick($event)"
                            >
                              {{
                                supplier.fielded === undefined
                                  ? 0
                                  : manageCap(supplier.fielded)
                              }}&nbsp;|&nbsp;{{
                                manageCap(supplier.completes_goal)
                              }}
                            </th>
                            <th
                              class="text-center"
                              (click)="avoidClick($event)"
                            >
                              {{ manageCap(supplier.current_target_stats) }}
                            </th>
                            <th
                              class="text-center"
                              (click)="avoidClick($event)"
                            >
                              {{ manageCap(supplier.currently_open_stats) }}
                            </th>
                            <th
                              class="text-center"
                              (click)="avoidClick($event)"
                            >
                              {{ manageCap(supplier.valid_click_sum) }}
                            </th>
                            <th
                              class="text-center"
                              (click)="avoidClick($event)"
                            >
                              {{
                                !supplier.last_start_date
                                  ? '-'
                                  : (supplier.last_start_date
                                    | date : 'MM/dd/yyyy h:mma')
                              }}
                            </th>
                            <th
                              class="text-center"
                              (click)="avoidClick($event)"
                            >
                              {{
                                !supplier.last_complete_date
                                  ? '-'
                                  : (supplier.last_complete_date
                                    | date : 'MM/dd/yyyy h:mma')
                              }}
                            </th>
                            <th
                              class="text-center"
                              (click)="avoidClick($event)"
                            >
                              {{ manageCap(supplier.buyer_in_progress) }}
                            </th>
                            <th class="text-center">&nbsp;</th>
                            <th class="text-center"></th>
                          </tr>
                        </table>
                      </ng-template>

                      <div id="{{ $index }}" class="accordian-body custom_bg">
                        <table
                          *ngFor="let quota of quotasForSupplierView | keyvalue"
                          aria-label="Supplier View Accordion expand"
                        >
                          <thead>
                            <tr>
                              <th class="text-left">{{ quota.key }}</th>

                              <th class="text-center">&nbsp;</th>
                              <th class="text-center">&nbsp;</th>
                              <th class="text-center">&nbsp;</th>
                              <th class="text-center">&nbsp;</th>
                              <th
                                class="text-center"
                                *ngIf="!filterCompanyDetail"
                              >
                                &nbsp;
                              </th>
                              <th
                                class="text-center"
                                *psUiHasRole="['operator']"
                              >
                                &nbsp;
                              </th>
                              <th class="text-center">&nbsp;</th>
                              <th class="text-center">&nbsp;</th>
                            </tr>
                          </thead>
                          <tbody
                            *ngFor="let item of quota.value; let $index = index"
                            class="supplier-quota-accordion-tbl"
                          >
                            <tr>
                              <td
                                *ngIf="quota.key !== 'zipcodes'"
                                class="text-left supplier-quota-accordion-tfirst"
                                title="{{ item.marker }}"
                              >
                                {{ item.quota_title }}
                              </td>
                              <td
                                *ngIf="quota.key === 'zipcodes'"
                                class="text-left"
                                title="{{ item.marker }}"
                              >
                                <span
                                  data-toggle="modal"
                                  data-target="#groupZipcodesModal"
                                  (click)="
                                    openZipcodesGroupModalForQuotaTab(
                                      item.criteria[0]
                                    )
                                  "
                                >
                                  {{ item.quota_title }}
                                </span>
                              </td>
                              <td class="text-left">
                                {{
                                  supplier.group_ref &&
                                  item.suppliers[supplier.group_ref]
                                    ? item.suppliers[supplier.group_ref][
                                        'complete_fielded'
                                      ]
                                    : ''
                                }}&nbsp;|&nbsp;
                                {{
                                  supplier.group_ref &&
                                  item.suppliers[supplier.group_ref]
                                    ? item.suppliers[supplier.group_ref][
                                        'complete_needed'
                                      ]
                                    : ''
                                }}
                              </td>
                              <td class="text-center">
                                {{
                                  supplier.group_ref &&
                                  item.suppliers[supplier.group_ref]
                                    ? manageCap(
                                        item.suppliers[supplier.group_ref][
                                          'current_target'
                                        ] || 0
                                      )
                                    : 0
                                }}
                              </td>
                              <td class="text-center">
                                {{
                                  item.locked === true
                                    ? 0
                                    : supplier.group_ref &&
                                      item.suppliers[supplier.group_ref]
                                    ? manageCap(
                                        item.suppliers[supplier.group_ref][
                                          'sup_currently_open'
                                        ] || 0
                                      )
                                    : 0
                                }}
                              </td>
                              <td class="text-center">
                                {{
                                  supplier.group_ref &&
                                  item.suppliers[supplier.group_ref]
                                    ? manageCap(
                                        item.suppliers[supplier.group_ref][
                                          'buyer_valid_clks'
                                        ] || 0
                                      )
                                    : 0
                                }}
                              </td>
                              <td class="text-center">
                                {{
                                  supplier.group_ref &&
                                  item.suppliers[supplier.group_ref]
                                    ? !item.suppliers[supplier.group_ref]
                                        .last_start_date
                                      ? '-'
                                      : (item.suppliers[supplier.group_ref]
                                          .last_start_date
                                        | date : 'MM/dd/yyyy h:mma')
                                    : ''
                                }}
                              </td>
                              <td class="text-center">
                                {{
                                  supplier.group_ref &&
                                  item.suppliers[supplier.group_ref]
                                    ? !item.suppliers[supplier.group_ref]
                                        .last_complete_date
                                      ? '-'
                                      : (item.suppliers[supplier.group_ref]
                                          .last_complete_date
                                        | date : 'MM/dd/yyyy h:mma')
                                    : ''
                                }}
                              </td>
                              <td class="text-center">
                                {{
                                  supplier.group_ref &&
                                  item.suppliers[supplier.group_ref]
                                    ? manageCap(
                                        item.suppliers[supplier.group_ref][
                                          'bip'
                                        ] || 0
                                      )
                                    : 0
                                }}
                              </td>
                              <td class="text-center">
                                {{
                                  suppConversion(
                                    item.suppliers,
                                    supplier.group_ref
                                  )
                                }}
                              </td>
                              <td class="text-center">&nbsp;</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </ps-ui-accordion-section>
                  </ps-ui-accordion>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </ng-container>
      <!-- Price View -->
      <ng-container *ngIf="quotaViewFlags.priceview">
        <div *ngIf="quotaViewFlags.priceview">
          <ps-ui-price-view-block
            [surveyData]="survey"
            [quotas]="formatQuotas"
            (purePriceQuotaChanged)="updateQuotaPriceStats()"
          >
          </ps-ui-price-view-block>
        </div>
      </ng-container>
      <!-- Quota pagination -->
      <div class="quota-pagination" *ngIf="quotaLength < totalQuotas">
        <a
          class="page-link"
          (click)="showNextQuotas(Constants.SHOW_NEXT_QUOTAS_LABELS.LIMITED)"
          >Show next {{ Constants.QUOTAPAGELIMIT }} Quotas</a
        >
        <span class="quota-pagination-separator"> | </span>
        <a
          class="page-link"
          (click)="showNextQuotas(Constants.SHOW_NEXT_QUOTAS_LABELS.ALL)"
          >Show all Quotas({{ totalQuotas }})</a
        >
      </div>
    </div>
  </div>
  <!-- No existing quota-->
  <p class="text-center m-0 text-uppercase text-decor" *ngIf="!isQuotasExist">
    <strong>Survey has no Quotas</strong>
  </p>
</div>
<div id="quotas" *psUiHasRole="['supplier']">
  <div class="templateRoot group-edit" *ngIf="isQuotasExist">
    <!-- Search process -->
    <form class="form-inline">
      <div class="row">
        <div class="col-md-3 col-sm-12 inside_first_groupMgmt supplier-search">
          <div>Search Quotas</div>
          <div class="quota-search-container">
            <input
              type="text"
              name="quotaSearch"
              class="form-control"
              [(ngModel)]="quotaSearch"
              (change)="searchQuotas(quotaSearch)"
            />
            <span
              class="fa fa-times-circle form-control-feedback close-search"
              aria-hidden="true"
              (click)="searchQuotas('')"
              *ngIf="quotaSearch"
            ></span>
          </div>
        </div>
      </div>
    </form>
    <!-- Tabulated search result -->
    <div class="table-responsive quota-table">
      <!-- No Quota found in search -->
      <ng-container *ngIf="formatQuotas === {} || isObjKeysEmpty(formatQuotas)">
        <div class="surveyDetailsTableWrapper no-match-wrapper">
          <p class="text-center m-0 text-uppercase text-decor">
            <strong>No Matching Quotas Found</strong>
          </p>
        </div>
      </ng-container>
      <!-- Quota View - Simple Quotas -->
      <ng-container>
        <div
          class="surveyDetailsTableWrapper"
          *ngFor="let quota of formatQuotas | keyvalue"
        >
          <table
            class="table survey-detail-table"
            ng-class="{ 'supplier-dashboard-quotas': filterCompanyDetail }"
            aria-label="Quota View"
          >
            <thead>
              <tr class="sticky-header">
                <th class="text-left">
                  {{ quota.key }}
                </th>
                <th class="text-center">
                  {{
                    survey.click_balancing === 1
                      ? 'Click Fielded Vs Click Goal'
                      : 'Fielded Vs Goal'
                  }}
                </th>
                <th class="text-center">Supplier Currently Open</th>
                <th class="text-center">Last Complete Date</th>
              </tr>
            </thead>
            <tbody *ngFor="let item of quota.value; let i = index">
              <tr>
                <td
                  *ngIf="quota.key !== 'zipcodes'"
                  class="text-left"
                  title="{{ item.marker }}"
                >
                  <div class="hover-edit-quota">
                    <div class="quota-name" *ngIf="item && item.quota_title">
                      {{ item.quota_title }}
                      <em
                        data-toggle="modal"
                        [attr.data-target]="'#Nickname_' + item.ps_quota_id"
                        class="fa fa-pencil edit-quota-pencil glyphicon glyphicon-pencil"
                        (click)="
                          updateQuotaTitle(
                            item.ps_quota_id,
                            item.quota_title,
                            item.criteria,
                            quota.key,
                            i
                          )
                        "
                      ></em>
                    </div>
                  </div>
                  <a
                    *ngIf="!item.isUnknown"
                    (click)="
                      lockQuota(
                        survey.id,
                        quota.key,
                        item.ps_quota_id,
                        !item.locked,
                        i
                      );
                      avoidClick($event)
                    "
                    class="lockQuotasIcon"
                  >
                    <img
                      [src]="
                        item.locked === true ? lockQuotaImg : unLockQuotaImg
                      "
                      alt="lock_quota"
                      class="img-responsive"
                    />
                  </a>
                </td>
                <td
                  *ngIf="quota.key === 'zipcodes'"
                  class="text-left"
                  title="{{ item.marker }}"
                >
                  <div
                    *ngIf="!item.isUnknown"
                    class="expanded_quota_modal"
                    mouseover="$event.stopPropagation(); checkhover = false;"
                  >
                    <em
                      data-toggle="modal"
                      data-target="#quota-Info-modal"
                      class="fa fa-ellipsis-h"
                      (click)="openInfoSupplierModal(item)"
                    ></em>
                  </div>
                  <span
                    data-toggle="modal"
                    data-target="#groupZipcodesModal"
                    (click)="
                      openZipcodesGroupModalForQuotaTab(item.criteria[0])
                    "
                  >
                    {{ item.quota_title }}
                  </span>
                  <a
                    *ngIf="!item.isUnknown"
                    (click)="avoidClick($event)"
                    class="lockQuotasIcon"
                  >
                    <img
                      [src]="
                        item.locked === true ? lockQuotaImg : unLockQuotaImg
                      "
                      alt="lock_quota"
                      class="img-responsive"
                    />
                  </a>
                </td>
                <td class="text-center">
                  {{
                    survey.click_balancing === 1
                      ? manageCap(item.buyer_valid_clks)
                      : manageCap(item.quantities.achieved)
                  }}&nbsp;|&nbsp;{{ manageCap(item.quantities.remaining) }}
                </td>
                <td class="text-center">
                  {{ manageCap(item.quantities.currently_open) }}
                </td>
                <td class="text-center">
                  {{ !item.last_complete_date ? '-' : item.last_complete_date }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </ng-container>
      <!-- Quota Pagination -->
      <div class="quota-pagination" *ngIf="quotaLength < totalQuotas">
        <a
          class="page-link"
          (click)="showNextQuotas(Constants.SHOW_NEXT_QUOTAS_LABELS.LIMITED)"
          >Show next {{ Constants.QUOTAPAGELIMIT }} Quotas</a
        >
        <span class="quota-pagination-separator"> | </span>
        <a
          class="page-link"
          (click)="showNextQuotas(Constants.SHOW_NEXT_QUOTAS_LABELS.ALL)"
          >Show all Quotas({{ totalQuotas }})</a
        >
      </div>
    </div>
  </div>
  <!-- No existing quota-->
  <p class="text-center m-0 text-uppercase text-decor" *ngIf="!isQuotasExist">
    <strong>Survey has no Quotas</strong>
  </p>
</div>
